const tax_receipts = {
  sequence: 'No de recu',
};
export default tax_receipts;
